import { render } from "./activeity-item.vue?vue&type=template&id=9967f7ba&scoped=true&ts=true"
import script from "./activeity-item.vue?vue&type=script&lang=tsx"
export * from "./activeity-item.vue?vue&type=script&lang=tsx"

import "./activeity-item.vue?vue&type=style&index=0&id=9967f7ba&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9967f7ba"]])

export default __exports__